import { Grid, TextField, InputAdornment } from "@mui/material";
import { forwardRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router";
import { NumericFormat } from "react-number-format";
import {
  JClearance,
  setCashFromRepDialog,
} from "../../../../../app/slices/jomla/clearanceSlice";
import { SelectJSafe } from "../../../../../components/Selectors/jomla/SelectJSafe";
import { HiOutlineBanknotes, HiOutlineInboxArrowDown } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../../components/FormDialog";

const CashFromRepForm = () => {
  const { user_id } = useParams();
  const dispatch = useDispatch();

  const [reload, setReload] = useState(false);

  const _JCashFromRep = useSelector((state) => state.jClearance.cashFromRep);
  const jSafe = useSelector((state) => state.jSafe.jSafes.data);
  const searchBody = useSelector((state) => state.jClearance.searchBody);

  const { control, handleSubmit, setValue } = useForm({
    defaultValues: _JCashFromRep.form,
  });

  const onSubmit = (data) => {
    data.rep_id = user_id;
    dispatch(JClearance.cashFromRep(data, searchBody)).then((x) => {
      setReload(!reload);
    });
  };

  const handleDialog = () => {
    dispatch(setCashFromRepDialog());
  };

  const NumericFormatCustom = forwardRef(function NumericFormatCustom(
    props,
    ref
  ) {
    const { onChange, ...other } = props;

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
        thousandSeparator
        valueIsNumericString
      />
    );
  });
  return (
    <FormDialog
      open={_JCashFromRep.dialog}
      onClose={handleDialog}
      maxWidth={"md"}
      icon={<HiOutlineInboxArrowDown />}
      title={"استلام نقد من المندوب"}
      subtitle="أدخل المبلغ واختر القاصة ثم اضغط تسديد"
      onSubmit={handleSubmit(onSubmit)}
      saveText="تسديد"
    >
      <SectionCard icon={<HiOutlineBanknotes />} title="معلومات الاستلام">
        <Grid item xs={12} sm={6}>
          <Controller
            name="amount"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="المبلغ"
                fullWidth
                {...field}
                InputProps={{
                  inputComponent: NumericFormatCustom,
                  startAdornment: (
                    <InputAdornment position="start">IQD</InputAdornment>
                  ),
                }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Controller
            name="safe_id"
            control={control}
            render={({ field }) => (
              <SelectJSafe
                {...field}
                required
                onChange={(e, newValue) => {
                  setValue("safe_id", newValue ? newValue.id : null);
                }}
                value={jSafe.filter((x) => x.id === field.value)[0] ?? null}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="note"
            control={control}
            render={({ field }) => (
              <TextField
                size="small"
                label="ملاحظات"
                fullWidth
                multiline
                rows={4}
                {...field}
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default CashFromRepForm;
